module.exports = __webpack_public_path__ + "static/media/about-2-bg.011111bd.jpg";